import { render, staticRenderFns } from "./HeaderSwitcher.vue?vue&type=template&id=14f9ede9&scoped=true&"
import script from "./HeaderSwitcher.vue?vue&type=script&lang=js&"
export * from "./HeaderSwitcher.vue?vue&type=script&lang=js&"
import style0 from "./HeaderSwitcher.vue?vue&type=style&index=0&id=14f9ede9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14f9ede9",
  null
  
)

export default component.exports